import { useEffect, useState } from 'react'

export const useTime = (sec, qualifiers) => {
    const [time, setTime] = useState("")

    useEffect(() => {
        if (sec === 0) {
            setTime('0 Sekunden')
            return
        }

        let sec_num = sec
        const days = Math.floor(sec_num / 86400)
        sec_num -= days * 86400
        const hours = Math.floor(sec_num / 3600)
        const minutes = Math.floor((sec_num - (hours * 3600)) / 60)
        const seconds = sec_num - (hours * 3600) - (minutes * 60)

        let usedQualifiers = 0
        let toReturn = ''

        if (days !== 0) {
            toReturn += days + (days === 1 ? ' Tag ' : ' Tage ')
            usedQualifiers++
        }
        if (usedQualifiers < qualifiers && hours !== 0) {
            toReturn += hours + (hours === 1 ? ' Stunde ' : ' Stunden ')
            usedQualifiers++
        }
        if (usedQualifiers < qualifiers && minutes !== 0) {
            toReturn += minutes + (minutes === 1 ? ' Minute ' : ' Minuten ')
            usedQualifiers++
        }
        if (usedQualifiers < qualifiers && seconds !== 0) {
            toReturn += seconds + (seconds === 1 ? ' Sekunde ' : ' Sekunden ')
        }

        setTime(toReturn.trim())
    }, [sec, qualifiers])

    return { time }
}